import request from '@/utils/request';

// 주소록관리 -  검색
export function getContactMngList(data) {
	return request({
		url: '/v2/contact/contactMngList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록그룹 - 리스트
export function getGroupList(data) {
	return request({
		url: '/v2/contact/groupList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록그룹 - 등록
export function addGroup(data) {
	return request({
		url: '/v2/contact/addGroup',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록그룹명 - 수정
export function updateGroupName(data) {
	return request({
		url: '/v2/contact/updateGroupName',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록그룹 - 삭제
export function deleteGroup(data) {
	return request({
		url: '/v2/contact/deleteGroup',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록 - 검색
export function getListInGroup(data) {
	return request({
		url: '/v2/contact/listInGroup',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록 - 검색 (주문, 설문주문)
export function getListInGroupOrder(data) {
	return request({
		url: '/v2/contact/listInGroupOrder',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록 - 등록
export function addInGroup(data) {
	return request({
		url: '/v2/contact/addInGroup',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록 - 수정
export function updateInGroup(data) {
	return request({
		url: '/v2/contact/updateInGroup',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 주소록 - 삭제
export function deleteInGroup(data) {
	return request({
		url: '/v2/contact/deleteInGroup',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 연락처 목록 조회
export function getContactManagerList(data) {
	return request({
		url: '/contact/manage/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 연락처 선택 삭제
export function contactManageDelete(data) {
	return request({
		url: '/contact/manage/delete',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 연락처 등록
export function contactSingleAdd(data) {
	return request({
		url: '/contact/manage/single/add',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 태그 설정 - 태그등록
export function contactTagSave(data) {
	return request({
		url: '/contact/tags/save',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 태그 설정 - 태그등록 - 태그명 유효성 검사
export function contactTagValidate(data) {
	return request({
		url: '/contact/tags/validate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 태그 설정 태그 목록 조회 연락처 연결 포함
export function getTagList(data) {
	return request({
		url: '/contact/tags/list',
		method: 'get',
		headers: { 'Content-Type': 'application/json' },
		data: {},
		params: {
			...data,
		},
	});
}

// 연락처관리 - 태그 목록 전체 조회, 검색 포함
export function getContactTagListAll(data) {
	return request({
		url: '/contact/tags',
		method: 'get',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처 상세 조회
export function getCurrentDetailData(contactSeq) {
	return request({
		url: `/contact/manage/${contactSeq}/detail `,
		method: 'get',
		headers: { 'Content-Type': 'application/json' },
		data: {},
	});
}

// 연락처관리 - 태그 설정 - 태그 삭제
export function contactTagDelete(data) {
	return request({
		url: '/contact/tags/delete',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 연락처관리 - 연락처 관리 상세 - 수정
export function contactDetailUpdate(data) {
	return request({
		url: '/contact/manage/detail/save',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
